'use strict';

// top header scroll
$(function() {
	$(window).scroll(function() {
		const scroll = $(window).scrollTop();
		const fv = window.screen.height;
		if (scroll >= fv) { 
		$("header").addClass("header-color");
		} else {
		$("header").removeClass("header-color");
		}
	});
});

// TOP 横スクロールパララックス

$(function() {
	const scrollItem = document.querySelectorAll('.js-slider-item');
	const scrollContainer = document.querySelector('.js-slider-wrap');
	const scrollContainer_sp = document.querySelector('.js-slider-wrap_sp');

	if (window.matchMedia( "(max-width: 768px)" ).matches) {
		const scrollTween = gsap.to(scrollItem, {
			yPercent: -100 * (scrollItem.length - 1),
			ease: "none",
		});

		const horizontalScroll = ScrollTrigger.create({
			trigger: scrollContainer,
			start: "top top+=380px",
			end: ()=>"+=" + (scrollContainer.offsetWidth - innerWidth),
			//end: () => '+=' + scrollContainer.offsetWidth,
			pin: !0,
			pinSpacing: 1,
			anticipatePin: 1,
			scrub: 0,
			invalidateOnRefresh: !0,
			animation: scrollTween
		
			// animation: scrollTween,
			// trigger: scrollContainer,
			// pin: true,
			// scrub: 1,
			// end: () => '+=' + scrollContainer.offsetWidth
		});
		const horizontalScroll_sp = ScrollTrigger.create({
			trigger: scrollContainer_sp,
			start: "top-=45px top",
			end: ()=>"+=" + (scrollContainer.offsetWidth - innerWidth),
			//end: () => '+=' + scrollContainer.offsetWidth,
			pin: !0,
			pinSpacing: 0,
			anticipatePin: 1,
			scrub: 0,
			invalidateOnRefresh: !0,
		
			// animation: scrollTween,
			// trigger: scrollContainer,
			// pin: true,
			// scrub: 1,
			// end: () => '+=' + scrollContainer.offsetWidth
		});
	} else {
		const scrollTween = gsap.to(scrollItem, {
			xPercent: -100 * (scrollItem.length - 1),
			ease: "none",
		});

		const horizontalScroll = ScrollTrigger.create({
			trigger: scrollContainer,
			start: "top-=375px top",
			end: ()=>"+=" + (scrollContainer.offsetWidth - innerWidth),
			//end: () => '+=' + scrollContainer.offsetWidth,
			pin: !0,
			pinSpacing: 1,
			anticipatePin: 1,
			scrub: 0,
			invalidateOnRefresh: !0,
			animation: scrollTween

			// snap: {
            //     snapTo: 1 / (scrollItem.length - 1),
            //     duration: {
            //         min: .25,
            //         max: .75
            //     },
            //     ease: "power1.inOut"
            // }
		});
		const horizontalScroll_sp = ScrollTrigger.create({
			trigger: scrollContainer_sp,
			start: "top-=75px top",
			end: ()=>"+=" + (scrollContainer.offsetWidth - innerWidth),
			//end: () => '+=' + scrollContainer.offsetWidth,
			pin: !0,
			pinSpacing: 0,
			anticipatePin: 1,
			scrub: 0,
			invalidateOnRefresh: !0,
		
			// animation: scrollTween,
			// trigger: scrollContainer,
			// pin: true,
			// scrub: 1,
			// end: () => '+=' + scrollContainer.offsetWidth
		});
	}
});



// const container = document.querySelector('.js-slider-wrap');
// const height = container.clientHeight;//コンテンツの高さを取得
// document.body.style.height = `${height}px`;//bodyタグにスタイル付与

// gsap.to(container, {
//   y: -(height - document.documentElement.clientHeight),//ページ内要素の高さ - ウインドウの高さ
//   ease: 'none',
//   scrollTrigger: {
//     trigger: document.body,
//     start: 'top top',
//     end: 'bottom bottom',
//     scrub: 1,
//   },
// });


$(function(){
	$(".bg01").each(function(i, elem){
	$(window).on("load scroll resize", function(){
		const slideritem = document.querySelectorAll('.bg01');
		const slideritemStyle = window.getComputedStyle(slideritem [0]);
		const slideritemStyleTransform = slideritemStyle.getPropertyValue('transform');

		//画像を取得
		const event1 = document.querySelector('.event1');
		const event2 = document.querySelector('.event2');
		const event3 = document.querySelector('.event3');
		const event4 = document.querySelector('.event4');
		const event5 = document.querySelector('.event5');
		const event6 = document.querySelector('.event6');
		const event7 = document.querySelector('.event7');


		if (window.matchMedia( "(max-width: 768px)" ).matches) {
			const slideritemMatrix = slideritemStyleTransform.match(/^matrix\((.+)\)$/)[1].split(', ');
			const slider = document.querySelector('.c-slider-1');
			slider.style.display = 'block';

			const slideritemTranslateY = slideritemMatrix[5];
			const event1Style = (Math.abs(slideritemTranslateY) / ($(elem).width() / 100) / 2) -10;

			//clip-pathを指定
			event1.style.clipPath = 'inset(0% 0% '+event1Style+'% 0%)';
			
			if (110 < event1Style) {
				const event2Style = event1Style -110;
							
				//clip-pathを指定
				event2.style.clipPath = 'inset(0% 0% '+event2Style+'% 0%)';
			}else{
				event2.style.clipPath = 'inset(0% 0% 0% 0%)';
			}

			if (220 < event1Style) {
				const event3Style = event1Style -220;
							
				//clip-pathを指定
				event3.style.clipPath = 'inset(0% 0% '+event3Style+'% 0%)';
			}else{
				event3.style.clipPath = 'inset(0% 0% 0% 0%)';
			}

			if (330 < event1Style) {
				const event4Style = event1Style -330;
							
				//clip-pathを指定
				event4.style.clipPath = 'inset(0% 0% '+event4Style+'% 0%)';
			}else{
				event4.style.clipPath = 'inset(0% 0% 0% 0%)';
			}
			
			if (440 < event1Style) {
				const event5Style = event1Style -440;
							
				//clip-pathを指定
				event5.style.clipPath = 'inset(0% 0% '+event5Style+'% 0%)';
			}else{
				event5.style.clipPath = 'inset(0% 0% 0% 0%)';
			}
			
			if (550 < event1Style) {
				const event6Style = event1Style -550;
							
				//clip-pathを指定
				event6.style.clipPath = 'inset(0% 0% '+event6Style+'% 0%)';
			}else{
				event6.style.clipPath = 'inset(0% 0% 0% 0%)';
			}
						
			if (660 < event1Style) {
				const event7Style = event1Style -660;
				
				//clip-pathを指定
				event7.style.clipPath = 'inset(0% 0% 0% 0%)';
			}else{
				event7.style.clipPath = 'inset(0% 0% 0% 0%)';
			}
		}else{
			const slideritemMatrix = slideritemStyleTransform.match(/^matrix\((.+)\)$/)[1].split(', ');
			const slideritemTranslateX = slideritemMatrix[4];
			const event1Style = (Math.abs(slideritemTranslateX) / ($(elem).width() / 100) / 2) - 5;

			//clip-pathを指定
			event1.style.clipPath = 'inset(0% '+event1Style+'% 0% 0%)';
			if (100 < event1Style) {
				const event2Style = event1Style -100;
				//clip-pathを指定
				event2.style.clipPath = 'inset(0% '+event2Style+'% 0% 0%)';
			}else{
				event2.style.clipPath = 'inset(0% 0% 0% 0%)';
			}
			if (200 < event1Style) {
				const event3Style = event1Style -200;
				//clip-pathを指定
				event3.style.clipPath = 'inset(0% '+event3Style+'% 0% 0%)';
			}else{
				event3.style.clipPath = 'inset(0% 0% 0% 0%)';
			}
			if (300 < event1Style) {
				const event4Style = event1Style -300;
				//clip-pathを指定
				event4.style.clipPath = 'inset(0% '+event4Style+'% 0% 0%)';
			}else{
				event4.style.clipPath = 'inset(0% 0% 0% 0%)';
			}
			if (400 < event1Style) {
				const event5Style = event1Style -400;
				//clip-pathを指定
				event5.style.clipPath = 'inset(0% '+event5Style+'% 0% 0%)';
			}else{
				event5.style.clipPath = 'inset(0% 0% 0% 0%)';
			}
			if (500 < event1Style) {
				const event6Style = event1Style -500;
				//clip-pathを指定
				event6.style.clipPath = 'inset(0% '+event6Style+'% 0% 0%)';
			}else{
				event6.style.clipPath = 'inset(0% 0% 0% 0%)';
			}
			if (600 < event1Style) {
				const event7Style = event1Style -600;
				//clip-pathを指定
				event7.style.clipPath = 'inset(0% 0% 0% 0%)';
			}else{
				event7.style.clipPath = 'inset(0% 0% 0% 0%)';
			}
		}
	});
	});
});

// $(function() {
// 	const slideritem = document.querySelectorAll('.js-slider-item');
// 	const slideritemStyle = window.getComputedStyle(slideritem [0]);
// 	const slideritemStyleTransform = slideritemStyle.getPropertyValue('transform');
// 	console.log(slideritemStyleTransform);
// 	//画像を取得
// 	const event1 = document.querySelector('.event1');
// 	//clip-pathを指定
// 	event1.style.clipPath = 'inset(0% 50% 0% 0%)';
// });

// 慣性スクロール


// const lenis = new Lenis({
// 	lerp: 0.05, // 慣性の強さ
// 	smoothWheel: true,
// 	//content: anchor,
// 	//duration: 1, // スクロールアニメーションの時間
// 	//easing: easeOutQuart, // イージング関数
// });

// lenis.on('scroll', ScrollTrigger.update)

// function raf(time) {
//   lenis.raf(time);
//   requestAnimationFrame(raf);
// }
// requestAnimationFrame(raf);








//Line up random
// $(function() {
// 	var box = [];
// 	$('.c-slide1__item').each(function() {
// 			box.push($(this).html());
// 	});
// 	box.sort(function() {
// 			return Math.random() - Math.random();
// 	});
// 	$('.c-slide1__item').empty();
	
// 	var i = 0;
// 	$('.c-slide1__item').each(function() {
// 			$(this).append(box[i]);
// 			i++;
// 	});
// });




// var breakPoint1 = 767;
// var Scrollbar = window.Scrollbar;
// var ScrollbarWidth = 0;

// function spCheck() {
// return $(window).width() <= breakPoint1;
// }

$(document).ready(function () {
var $body = $('body');
var wrapperScroll = null;





$('.c-mv').each(function () {
	var $this = $(this);
	var item = $('.c-mv__item', $this);

	if (item.length >= 2) {
	var current = $('.c-mv__item.current', $this);

	if (!current.length) {
		item.eq(0).addClass('current');
	}

	setInterval(function () {
		var $hidden = $('.c-mv__item.current', $this);
		var $next = $hidden.next('.c-mv__item');

		if (!$next.length) {
		$next = item.eq(0);
		}

		item.removeClass("top-hidden");
		$hidden.removeClass("current").addClass("top-hidden");
		$next.addClass("current");
	}, 6500);
	}
});

$('.c-recycle').each(function () {
	var $this = $(this);
	var item = $('.c-recycle__item', $this);

	if (item.length >= 2) {
	var current = $('.c-recycle__item.current', $this);

	if (!current.length) {
		item.eq(0).addClass('current');
	}

	setInterval(function () {
		var $hidden = $('.c-recycle__item.current', $this);
		var $next = $hidden.next('.c-recycle__item');

		if (!$next.length) {
		$next = item.eq(0);
		}

		item.removeClass("hidden");
		$hidden.removeClass("current").addClass("hidden");
		$next.addClass("current");
	}, 6500);
	}
});

// $(function () {
// 	$(".-p0").addClass("is-current");

// 	// hoverする要素のclass名
// 	$(".-p0").hover(
// 	  function () {
// 		// hoverした時の処理(classを付与)
// 		$(".-p0").addClass("is-current");
// 	  },
// 	  function () {
// 		// hoverを外した時の処理(classを外す)
// 		$(".js-box").removeClass("js-hover");
// 	  }
// 	);
//   });












// 'use strict';

// var breakPoint1 = 767;
// var Scrollbar = window.Scrollbar;
// var ScrollbarWidth = 0;

// function spCheck() {
// 	return $(window).width() <= breakPoint1;
// }

// $(document).ready(function () {
// 	var $body = $('body');
// 	var wrapperScroll = null;

// 	function getScrollTop() {
// 	if (wrapperScroll) {
// 		return wrapperScroll.scrollTop;
// 	} else {
// 		return $(window).scrollTop();
// 	}
// 	}

// 	var htmlBodyAnimate = function htmlBodyAnimate(target) {
// 	if (wrapperScroll) {
// 		var scrollTop = 0;

// 		if (target.offset().top !== 0) {
// 		scrollTop = target.offset().top + wrapperScroll.scrollTop;
// 		}

// 		wrapperScroll.scrollTo(0, scrollTop, 800);
// 	} else {
// 		var targetPosition = target.offset().top;
// 		$('body, html').animate({
// 		scrollTop: targetPosition
// 		}, 800, 'swing');
// 	}
// 	};

// 	var loadAnchor = function loadAnchor() {
// 	var localLink = window.location + '';

// 	if (localLink.indexOf('#') !== -1) {
// 		var hash = localLink.slice(localLink.indexOf('#'));
// 		var dataAnchor = $('[data-anchor="' + hash.slice(1) + '"]');

// 		if ($(hash).length) {
// 		htmlBodyAnimate($(hash));
// 		} else if (dataAnchor.length) {
// 		htmlBodyAnimate(dataAnchor);
// 		}
// 	}
// 	};

// 	var fadeInScroll = function fadeInScroll() {
// 	$('.u-fadeIn').not('.show').each(function () {
// 		var targetTop,
// 			target = $(this);
// 		var numAdd = 50;

// 		if (wrapperScroll) {
// 		targetTop = target.offset().top + wrapperScroll.scrollTop;
// 		} else {
// 		targetTop = target.offset().top;
// 		}

// 		if (getScrollTop() > targetTop - ($(window).height() - numAdd)) {
// 		$(this).addClass('show');
// 		}
// 	});
// 	};

// 	var topMvScroll = function topMvScroll() {
// 	var mvTop = $('.c-top');

// 	if (mvTop.length) {
// 		if (getScrollTop() >= mvTop.outerHeight()) {
// 		mvTop.addClass('is-hidden');
// 		} else {
// 		mvTop.removeClass('is-hidden');
// 		}
// 	}
// 	};

// 	var topLogoScroll = function topLogoScroll() {
// 	var logo = $('body.page-top .c-header__logo');

// 	if (logo.length) {
// 		if (getScrollTop() >= $(window).height()) {
// 		logo.addClass('is-show');
// 		} else {
// 		logo.removeClass('is-show');
// 		}
// 	}
// 	};

// 	// var footerFixCheck = function footerFixCheck() {
// 	// var wrapper = $('#wrapper');
// 	// var footer = $('footer');
// 	// var main = $('main');

// 	// if (wrapper.length && footer.length && main.length) {
// 	// 	if ($(window).height() < footer.outerHeight()) {
// 	// 	main.addClass('footer-no-fixed');
// 	// 	footer.addClass('footer-no-fixed');
// 	// 	main.after(footer);
// 	// 	} else {
// 	// 	main.removeClass('footer-no-fixed');
// 	// 	footer.removeClass('footer-no-fixed');
// 	// 	footer.appendTo(wrapper);
// 	// 	}
// 	// }
// 	// };

// 	var baseWidth = function baseWidth() {
// 	var base = $('.js-base-width');

// 	if (base.length) {
// 		base.css('left', $(window).scrollLeft() * -1);
// 	}
// 	};

// 	$('#headerNavBar').on('click', function () {
// 	var menu = $('#headerNavMenu');

// 	if (menu.length) {
// 		$(this).toggleClass('open');
// 		$('header').toggleClass('open');
// 		$('body').toggleClass('header-open');
// 		menu.toggleClass('open');
// 	}
// 	});
// 	$('.c-mv').each(function () {
// 	var $this = $(this);
// 	var item = $('.c-mv__item', $this);

// 	if (item.length >= 2) {
// 		var current = $('.c-mv__item.current', $this);

// 		if (!current.length) {
// 		item.eq(0).addClass('current');
// 		}

// 		setInterval(function () {
// 		var $hidden = $('.c-mv__item.current', $this);
// 		var $next = $hidden.next('.c-mv__item');

// 		if (!$next.length) {
// 			$next = item.eq(0);
// 		}

// 		item.removeClass("hidden");
// 		$hidden.removeClass("current").addClass("hidden");
// 		$next.addClass("current");
// 		}, 6500);
// 	}
// 	});
// 	/* スムーズスクロール
// 	/*---------------------------------------------------------*/

// 	// $(document).on('click', 'a[href*="#"]', function (e) {
// 	// var hash = this.hash;
// 	// var target = $(hash === '#' || hash === '' ? 'html' : hash);

// 	// if (target.length === 0) {
// 	// 	target = $('[data-anchor="' + hash.slice(1) + '"]');
// 	// }

// 	// var locationPath = window.location.pathname.replace(/\//g, '');
// 	// var thisPath = this.pathname.replace(/\//g, '');

// 	// if (target.length && locationPath === thisPath) {
// 	// 	e.preventDefault();

// 	// 	var scrollStop = function scrollStop() {
// 	// 	$('body, html').stop(true);
// 	// 	};

// 	// 	if ($(this).parents('.c-header__collapse').length) {
// 	// 	$('.c-header__navbar.open').trigger('click');
// 	// 	setTimeout(function () {
// 	// 		htmlBodyAnimate(target);
// 	// 	}, 300);
// 	// 	} else {
// 	// 	htmlBodyAnimate(target);
// 	// 	}

// 	// 	window.addEventListener('DOMMouseScroll', scrollStop, false);
// 	// 	window.onmousewheel = document.onmousewheel = scrollStop;
// 	// }
// 	// });
// 	$('.c-slide1').each(function () {
// 	Scrollbar.init(this, {}); 
// 	//  $(this).slick({
// 	// 	dots: false,
// 	// 	arrow: true,
// 	// 	infinite: false,
// 	// 	slidesToShow: 5,
// 	// 	slidesToScroll: 1,
// 	// 	slidesPerView: 1.23,
// 	// 	swipeToSlide: true,
// 	// 	useTransform: false,
// 	// 	speed: 400,
// 	// 	responsive: [
// 	// 		{
// 	// 			breakpoint: 767,
// 	// 			settings: {
// 	// 				slidesToShow: 1,
// 	// 				slidesToScroll: 1,
// 	// 			}
// 	// 		}
// 	// 	]
// 	// });
// 	});
// 	$('.c-slide2').each(function () {
// 	var $this = $(this);
// 	var swiper = new Swiper(this, {
// 		direction: 'horizontal',
// 		slidesPerView: 1,
// 		spaceBetween: 0,
// 		watchOverflow: true,
// 		freeMode: false,
// 		loop: false,
// 		navigation: {
// 		nextEl: '.swiper-button-next',
// 		prevEl: '.swiper-button-prev'
// 		},
// 		scrollbar: {
// 		el: '.swiper-scrollbar',
// 		draggable: true //dragSize: 50

// 		}
// 	}); //Scrollbar.init(this, {});
// 	// let slide2 = $(this).slick({
// 	// 	dots: true,
// 	// 	arrow: true,
// 	// 	infinite: false,
// 	// 	slidesToShow: 1,
// 	// 	slidesToScroll: 1,
// 	// 	swipeToSlide: false,
// 	// 	useTransform: false,
// 	// 	edgeFriction: 0,
// 	// 	speed: 400,
// 	// }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
// 	// 	let dots = $('.slick-dots', slide2);
// 	// 	if (dots.length) {dots.addClass('show');}
// 	// 	let dot = $('.slick-dots li:first-child', slide2);
// 	// 	if (dot.length) {
// 	// 		let calc = ((nextSlide) / (slick.slideCount - 1)) * 100;
// 	// 		let width = dot.outerWidth();
// 	// 		let add = width / 2;
// 	// 		if (calc === 0) {
// 	// 			add = 0;
// 	// 		} else if (calc === 100) {
// 	// 			add = width;
// 	// 		}
// 	// 		dot.css("left", 'calc(' + calc + '% - ' + add + 'px)');
// 	// 	}
// 	// });
// 	//
// 	// $(this).on('touchstart', function () {
// 	// 	$(this).addClass('touchstart');
// 	// 	let dots = $('.slick-dots', slide2);
// 	// 	if (dots.length) {dots.addClass('show');}
// 	// });
// 	});
// 	$('.c-slide3').each(function () {
// 	Scrollbar.init(this, {}); // $(this).slick({
// 	// 	dots: false,
// 	// 	arrow: true,
// 	// 	infinite: false,
// 	// 	slidesToShow: 4,
// 	// 	slidesToScroll: 1,
// 	// 	adaptiveHeight: true,
// 	// 	useTransform: false,
// 	// 	swipeToSlide: true,
// 	// 	speed: 400,
// 	// 	responsive: [
// 	// 		{
// 	// 			breakpoint: 767,
// 	// 			settings: {
// 	// 				slidesToShow: 2,
// 	// 				slidesToScroll: 1,
// 	// 			}
// 	// 		}
// 	// 	]
// 	// });
// 	});

// 	(function () {
// 	var box2map = $('.c-box2__map');

// 	if (box2map.length) {
// 		box2map.click(function () {
// 		$(this).find('iframe').addClass('clicked');
// 		}).mouseleave(function () {
// 		$(this).find('iframe').removeClass('clicked');
// 		});
// 	}
// 	})();

// 	(function () {
// 	var div = document.createElement('div');
// 	div.style.setProperty('display', 'none');
// 	div.style.setProperty('width', '100vw');
// 	$(div).appendTo($('body'));
// 	var style = document.createElement('style');
// 	document.getElementsByTagName("head")[0].appendChild(style);

// 	var updateScrollBar = function updateScrollBar() {

// 		var wrapperBody = $('#wrapper-body');

// 		if (wrapper.length && wrapperBody.length) {
// 		var footerHeight = $('footer').outerHeight();
// 		wrapper.css('margin-bottom', footerHeight);
// 		wrapperBody.css('min-height', $(window).height() - footerHeight);
// 		}

// 		var barWidth = Math.round($(div).width() - $(window).width());
// 		style.innerHTML = ':root {--scroll-bar-width: ' + barWidth + 'px}';
// 		ScrollbarWidth = barWidth - 400;
// 	};

// 	if (typeof ResizeObserver === 'function') {
// 		var resizeObserver = new ResizeObserver(function () {
// 		updateScrollBar();
// 		});
// 		resizeObserver.observe(document.getElementsByTagName("BODY")[0]);
// 	}

// 	window.addEventListener("resize", updateScrollBar);
// 	window.addEventListener("load", updateScrollBar);
// 	updateScrollBar();
// 	})();

// 	if ($body.hasClass('is-scrollbar')) {
// 	if (ScrollbarWidth > 1) {
// 		$body.addClass('js-scrollbar');
// 		wrapperScroll = Scrollbar.init(document.getElementById('wrapper-scroll'), {
// 		damping: 0.04,
// 		delegateTo: document.getElementsByTagName("BODY")[0]
// 		});
// 		wrapperScroll.addListener(function () {
// 		fadeInScroll();
// 		topLogoScroll();
// 		topMvScroll();
// 		baseWidth();
// 		});
// 	}
// 	}

// 	// footerFixCheck();
// 	fadeInScroll();
// 	topLogoScroll();
// 	topMvScroll();
// 	baseWidth();
// 	$(window).on('resize', function () {
// 	topMvScroll();
// 	baseWidth();
// 	}).on('scroll', function () {
// 	fadeInScroll();
// 	topLogoScroll();
// 	topMvScroll();
// 	baseWidth();
// 	}).on('load', function () {
// 	footerFixCheck();
// 	loadAnchor();
// 	baseWidth();
// 	});
// 	$body.addClass('loaded');
// });





// $body.addClass('loaded');
});